import { PreOrderService } from './pre-order/pre-order.service';

export const Api = [PreOrderService];

export * from './pre-order/pre-order.service';
